import { alpha, useTheme } from '@mui/material';
export const useEditDashboardStyles = () => {
    const theme = useTheme();
    return {
        dialogContentStyle: {
        // maxHeight: '70dvh',
        // overflowY: 'auto'
        },
        alertStyle: {
            backgroundColor: alpha(theme.palette.info.main, 0.08),
            border: `1px solid ${alpha(theme.palette.info.main, 0.16)}`,
            borderRadius: '8px'
        },
        getStepBoxStyle: (isAdded) => ({
            borderRadius: '20px',
            px: '12px',
            py: '9.5px',
            gap: 1,
            bgcolor: alpha(theme.palette.primary.main, 0.08),
            border: `2px solid ${isAdded ? theme.palette.primary.dark : 'transparent'}`
        }),
        mobileDrawerStyle: {
            p: 2,
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16
        },
        appBarStyle: {
            bgcolor: 'background.paper',
            borderBottom: `1px solid ${theme.palette.divider}`,
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16
        },
        mobileToolbarStyle: {
            justifyContent: 'space-between',
            minHeight: '64px !important'
        },
        footerBoxStyle: {
            p: 2,
            borderTop: `1px solid ${theme.palette.divider}`,
            bgcolor: 'background.paper',
            display: 'flex',
            gap: 1,
            flexDirection: 'row'
        }
    };
};
